export default __webpack_public_path__ + "static/media/excelIcon.9ca7fdc4.png";